/*
  История обращения с этим животным
*/

import './History.css';
import '../css/Main.css';
import React , { useState, useEffect } from 'react'
import axios_sender from '../modules/axios_sender.js'
import unique from '../modules/unique.js'



function History(props) {


  
  return (
    <>
    <div className="page-caption">История манипуляций</div>
      <div>
        </div>
    </>
  );

  


}

export default History;
